/* 孫吳傳・第 7 章：如期而返（建安初）
 * 史實：《三國志·太史慈傳》太史慈被擒，「策即解縛，捉其手曰：『寧識神亭時邪？若卿爾時得我云何？』慈曰：『未可量也。』」
 *       「後劉繇亡於豫章，士眾萬餘人未有所附，策命慈往撫安焉。左右皆曰：『慈必北去不還。』策曰：『子義捨我，當復與誰？』」
 *       送到昌門，問「何時能還？」慈答「不過六十日。」「果如期而反。」
 *       裴注引《吳歷》另有「明日中」為期、立竿視影的說法，裴松之評《吳歷》「與本傳大異，疑為謬誤」，這一章照正文的六十日。
 * 流程：操作太史慈，六十日（遊戲裡壓縮成 NOON 秒）內到各處找劉繇的殘部：願意歸附的站著說服（讀條），不服的打到認輸再收編 → 期滿前回孫策營。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, TROOPS } from '../kit.ts';

const CAMP = [900, 2900], LV = 9, NOON = 170, DAY = NOON / 60; // 六十日的期限，一日約 2.8 秒
// 殘部：[x, y, 人數, 服不服]
const GROUPS = [[2150, 1500, 3, true], [3100, 4300, 4, true], [5300, 2300, 4, false], [4800, 3300, 3, true], [6000, 1600, 4, false], [5800, 3800, 3, true]];
const LINES = ['劉使君已死，我們還能去哪……', '你是太史子義？你也降了孫郎？', '孫郎真的會收留我們？'];

export default {
  id: 'sunwu-7', map: 'shenting', hero: 'taishici',
  title: '第 6 章　如期而返', year: '建安初',
  brief: {
    quote: [
      { text: '策即解縛，捉其手曰：「寧識神亭時邪？若卿爾時得我云何？」慈曰：「未可量也。」', src: '《三國志·吳書·太史慈傳》' },
      { text: '左右皆曰：「慈必北去不還。」策曰：「子義捨我，當復與誰？」', src: '《太史慈傳》' },
      { text: '策問：「何時能還？」答：「不過六十日。」', src: '《太史慈傳》' },
    ],
    text: '太史慈被孫策所擒，孫策解縛相待。後來劉繇死在豫章，部眾萬餘人無所歸附，孫策派太史慈去撫安。身邊的人都說他一去不回；孫策送到昌門，問他何時能還，太史慈說不過六十日。',
    goals: ['找到劉繇的殘部，說服或收編', '六十日內回到孫策營'],
  },
  words: { ally: '歸附的殘部', foe: '不服的殘部' },
  stars: [
    { text: '帶回 15 人以上', ok: (m) => m.vars.back >= 15 },
    { text: '六處殘部全部收撫', ok: (m) => m.vars.done === GROUPS.length },
    { text: '期滿前十日以上就回營', ok: (m) => m.vars.leftT >= 10 * DAY },
  ],
  steps: [
    { // 1. 收撫殘部
      enter(m, w) {
        const me = w.player;
        setLevel(w, me, LV);
        me.x = CAMP[0] + 200; me.y = CAMP[1];
        m.vars.done = 0; m.vars.t0 = w.t;
        const ce = ally(w, 'sunce', CAMP[0] + 40, CAMP[1] - 80, LV);
        ce.hold = [CAMP[0] + 40, CAMP[1] - 80]; m.vars.ce = ce;
        m.vars.groups = GROUPS.map(([x, y, n, willing], g) => {
          const list = Array.from({ length: n }, (_, i) => {
            const o = { spec: TROOPS.liuyao, name: i ? '劉繇殘兵' : '劉繇舊部', hp: i ? 420 : 900, maxHp: i ? 420 : 900, atk: i ? 20 : 30 };
            const u = willing ? m.recruit(x + (i - 1) * 60, y + (i % 2) * 40, o.name) : m.foe(i ? 'huangjin' : 'bandit', x + (i - 1) * 60, y + (i % 2) * 40, o);
            if (willing) Object.assign(u, { spec: TROOPS.liuyao, hp: o.hp, maxHp: o.hp });
            u.group = g;
            return u;
          });
          m.mark('g' + g, x, y, willing ? '殘部' : '殘部（不服）', true);
          return { list, willing, x, y, done: false };
        });
        m.line('孫策', '子義，劉繇的舊部散在各處，就交給你了。何時能還？');
        m.after(3, () => m.line('太史慈', '不過六十日。'));
        m.after(7, () => m.line('提示', '願意歸附的殘部：站在他們身邊不動就能說服（被打斷要重來）。不服的：把領頭的打到認輸再收編。'));
        m.obj('groups', '收撫劉繇的殘部', GROUPS.length);
        m.obj('noon', '');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.groups.forEach((G, g) => {
          if (G.done) return;
          const lead = G.list[0];
          if (G.willing) {
            m.chanAt(me, 'g' + g, G.x, G.y, 180, 3, '說服', () => {
              G.done = true; V.done++; m.unmark('g' + g);
              for (const u of G.list) if (u.alive) m.join(u, me);
              m.line('劉繇舊部', LINES[g % LINES.length]);
              m.after(2.5, () => m.line('太史慈', '孫郎有容人之量。跟我走！'));
            });
          } else if (lead.alive && lead.hp < lead.maxHp * 0.4) {
            // 不服的：領頭的打到四成以下就認輸，整隊收編
            G.done = true; V.done++; m.unmark('g' + g);
            m.line('劉繇舊部', '……太史子義果然名不虛傳。我們服了！');
            for (const u of G.list) if (u.alive) { u.team = 0; u.recruit = true; u.target = null; u.aggro = null; u.home = null; u.hp = Math.max(u.hp, u.maxHp * 0.5); m.join(u, me); }
          } else if (!lead.alive) { G.done = true; V.done++; m.unmark('g' + g); for (const u of G.list) if (u.alive) { u.team = 0; u.recruit = true; u.target = null; u.home = null; m.join(u, me); } }
        });
        m.prog('groups', V.done);
        const left = NOON - (w.t - V.t0), o = m.get('noon');
        o.text = `六十日內回孫策營（第 ${Math.min(60, Math.floor((NOON - left) / DAY) + 1)} 日）`;
        if (left <= 0) { m.lose('過了六十日還沒回營'); return false; }
        if (V.done === GROUPS.length && !V.allDone) { V.allDone = true; m.mark('camp', CAMP[0], CAMP[1], '孫策營'); m.line('太史慈', '人都找齊了，回營！'); }
        if (left < 20 * DAY && !V.warned) { V.warned = true; m.mark('camp', CAMP[0], CAMP[1], '孫策營'); m.line('提示', '六十日之期只剩二十日，該回營了。'); }
        return V.done > 0 && m.near(me, CAMP[0], CAMP[1], 300);
      },
    },
    { // 2. 如期而返
      enter(m, w) {
        const V = m.vars;
        V.leftT = NOON - (w.t - V.t0);
        V.back = w.units.filter((u) => u.recruit && u.alive && u.owner === w.player).length;
        m.done('noon'); m.unmark('camp');
        m.card('果如期而反。', '《太史慈傳》');
        m.after(2, () => m.line('孫策', `子義果然回來了！還帶回了 ${V.back} 人！`));
        m.after(5, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('太史慈陣亡'); return; }
    if (m.vars.ce) allyTick(w, m.vars.ce, null, 400);
  },
};
